module.exports = "/_next/static/images/StreamlineAccess@3x-bc42f71f14aad838df6de0b03304e951.webp";